// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","321":"d282064a","455":"9694b23e","808":"3bbd3da6","977":"5a4c08f0","996":"7a2d86ea"}[chunkId] + ".chunk.js";
};